import { Button, CircularProgress, Grid } from '@mui/material';
import { useState } from 'react';
import amoCrm from 'assets/images/amo-crm-logo.bmp';
import onlinePbx from 'assets/images/online-pbx.png';
import utelLogo from 'assets/images/utel.png';
import myCallsLogo from 'assets/images/my-calls.png';
import telegramBot from 'assets/images/telegram-bot.png';
import AmoCrmSettings from './crmColumn elements/CrmAddEditModal';
import OnlinePbxSettings from './crmColumn elements/PbxAddEditModal';
import UtelSettings from './crmColumn elements/UtelAddEditModal';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { useQueries } from 'react-query';
import TgBotSettings from './crmColumn elements/TgBotAddEditModal';
import MyCallsAddEditModal from './crmColumn elements/MyCallsAddEditModal';

export default function SettingCrmColumn({ data }) {
  const [open, setOpen] = useState('');
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [selectedBot, setSelectedBot] = useState({});

  const [amo, pbx, bots, utel] = useQueries([
    {
      queryKey: '/admin/crm-settings/amocrm',
      queryFn: async function () {
        const response = await axiosPrivate.get(`/admin/crm-settings/amocrm`);
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
    {
      queryKey: '/admin/crm-settings/onlinepbx',
      queryFn: async function () {
        const response = await axiosPrivate.get(
          '/admin/crm-settings/onlinepbx'
        );
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
    {
      queryKey: '/admin/tgbot/index',
      queryFn: async function () {
        const response = await axiosPrivate.get('/admin/tgbot/index');
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
    {
      queryKey: '/admin/crm-settings/utel',
      queryFn: async function () {
        const response = await axiosPrivate.get('/admin/crm-settings/utel');
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
  ]);

  return (
    <Grid
      item={true}
      sm={1}
      xs={1}
      className={
        'min-w-72 [&>.crm-element-wrapper]:mb-4 !mr-4 !bg-[#FCFCFC] !p-2 !rounded-md !border !border-[#5959591A] overflow-y-auto my-scroll'
      }
    >
      <div className='crm-element-wrapper shadow-lg w-full h-32 overflow-hidden rounded-lg relative'>
        <img
          src={amoCrm}
          className='w-full h-full object-cover object-center'
          alt='amo crm'
        />
        <div className='absolute z-10 bottom-2 left-1/2 -translate-x-1/2'>
          <Button
            variant='outlined'
            color='primary'
            className='!border-gray-400 !text-gray-400 hover:!text-white hover:!border-white w-32'
            onClick={() => setOpen('amo')}
          >
            <i
              className={`bi ${amo?.data?.id ? 'bi-gear' : 'bi-plus-circle'}`}
            />
          </Button>
        </div>
      </div>
      <div className='crm-element-wrapper shadow-lg w-full h-32 overflow-hidden rounded-lg relative'>
        <img
          src={onlinePbx}
          className='w-full h-full object-cover object-center'
          alt='amo crm'
        />
        <div className='absolute z-10 bottom-2 left-1/2 -translate-x-1/2'>
          <Button
            variant='outlined'
            color='primary'
            className='!border-gray-400 !text-gray-400 hover:!text-blue-400 hover:!border-blue-400 w-32'
            onClick={() => setOpen('pbx')}
          >
            <i
              className={`bi ${pbx?.data?.id ? 'bi-gear' : 'bi-plus-circle'}`}
            />
          </Button>
        </div>
      </div>
      <div className='crm-element-wrapper shadow-lg px-5 w-full h-32 overflow-hidden rounded-lg relative'>
        <img
          src={utelLogo}
          className='w-full drop-shadow-lg h-full object-contain object-center'
          alt='amo crm'
        />
        <div className='absolute z-10 bottom-2 left-1/2 -translate-x-1/2'>
          <Button
            variant='outlined'
            color='primary'
            className='!border-gray-400 !text-gray-400 hover:!text-blue-400 hover:!border-blue-400 w-32'
            onClick={() => setOpen('utel')}
          >
            <i
              className={`bi ${utel?.data?.id ? 'bi-gear' : 'bi-plus-circle'}`}
            />
          </Button>
        </div>
      </div>
      <div className='crm-element-wrapper shadow-lg w-full h-32 overflow-hidden rounded-lg relative'>
        <img
          src={myCallsLogo}
          className='w-full h-full object-cover object-center'
          alt='Мои Звонки'
        />
        <div className='absolute z-10 bottom-2 left-1/2 -translate-x-1/2'>
          <Button
            variant='outlined'
            color='primary'
            className='!border-gray-400 !text-gray-400 hover:!text-blue-400 hover:!border-blue-400 w-32'
            onClick={() => setOpen('myCalls')}
          >
            <i
              className={`bi ${pbx?.data?.id ? 'bi-gear' : 'bi-plus-circle'}`}
            />
          </Button>
        </div>
      </div>
      <div className='crm-element-wrapper shadow-lg w-full rounded-lg relative'>
        <div className='crm-element-wrapper shadow-lg w-full h-36 overflow-hidden rounded-lg relative'>
          <img
            src={telegramBot}
            className='w-full h-full object-cover object-bottom'
            alt='amo crm'
          />
          <div className='absolute z-10 bottom-2 left-1/2 -translate-x-1/2'>
            <Button
              variant='outlined'
              color='primary'
              className='!border-gray-400 !text-gray-400 hover:!text-blue-400 hover:!border-blue-400 w-32'
              onClick={() => setOpen('bots')}
            >
              <i
                className={`bi ${pbx?.data?.id ? 'bi-gear' : 'bi-plus-circle'}`}
              />
            </Button>
          </div>
        </div>
        <div className='bg-gray-50 rounded-lg overflow-hidden'>
          {(bots.isLoading || bots.isFetching) && (
            <div className='flex justify-center items-center p-5'>
              <CircularProgress />
            </div>
          )}
          {!(bots.isLoading || bots.isFetching) &&
            bots?.data?.map((bot) => (
              <div
                key={bot?.id}
                className='p-1 px-2 flex justify-between items-center odd:bg-gray-100 hover:bg-gray-200 cursor-pointer'
              >
                <span>{bot?.name}</span>
                <Button
                  variant='text'
                  color='info'
                  onClick={() => {
                    setOpen('bots');
                    setSelectedBot(bot);
                  }}
                >
                  <i className='bi bi-pen' />
                </Button>
              </div>
            ))}
        </div>
      </div>
      <TgBotSettings
        refetch={bots?.refetch}
        data={selectedBot}
        open={open == 'bots'}
        setOpen={() => {
          setOpen(false);
          setSelectedBot({});
        }}
      />
      <AmoCrmSettings
        refetch={amo?.refetch}
        data={amo?.data}
        open={open == 'amo'}
        setOpen={setOpen}
      />
      <OnlinePbxSettings
        refetch={pbx?.refetch}
        data={pbx?.data}
        open={open == 'pbx'}
        setOpen={setOpen}
      />
      <UtelSettings
        refetch={utel?.refetch}
        data={utel?.data}
        open={open == 'utel'}
        setOpen={setOpen}
      />
      <MyCallsAddEditModal
        // refetch={myCalls?.refetch}
        // data={myCalls?.data}
        open={open == 'myCalls'}
        setOpen={setOpen}
      />
    </Grid>
  );
}
